import { Button } from '@moniebook-web/components/atoms/button';
import type { BackgroundSyncStatus as SyncStatus } from '@register-ui/utils';
import { BACKGROUND_SYNC_STATUS } from '@register-ui/utils';

interface Props {
    status: SyncStatus;
    onRetry?: VoidFunction;
}

const contentMap: Partial<Record<SyncStatus, string>> = {
    [BACKGROUND_SYNC_STATUS.Syncing]:
        'Syncing remaining items in the background. All items will be available once complete.',
    [BACKGROUND_SYNC_STATUS.Success]: 'All items synced and ready.',
    [BACKGROUND_SYNC_STATUS.Failed]: 'Background items sync failed.',
};

export function BackgroundItemsSyncIndicator({
    status,
    onRetry,
}: Readonly<Props>) {
    const content = contentMap[status];

    return (
        <div className='flex items-center justify-between'>
            <div className='flex gap-16 px-8'>{content}</div>

            {status === BACKGROUND_SYNC_STATUS.Syncing && (
                <div className='h-4 w-120 overflow-hidden rounded-8 bg-feedback-default-ghost-pressed'>
                    <div className='h-full animate-banner-progress bg-action-default-filled-default' />
                </div>
            )}

            {status === BACKGROUND_SYNC_STATUS.Failed && (
                <Button label='Retry' theme='secondary' onClick={onRetry} />
            )}
        </div>
    );
}
